import { SUPPORT_HELP_LINK } from '@/constants/general';
import { IUserSession } from '@typings/user-session';
import angular from 'angular';
import { snakeToCamelCase } from '@/utils/snakeCamelTransform';
import { UserSession } from '@/hooks/queries/useGetUserSessionQuery/types';

export const isSameBarCode = (a: string | null, b: string | null) => {
  if (!a || !b) return false;
  return a.toUpperCase() === b.toUpperCase();
};

export const contactSupport = () => {
  window.open(SUPPORT_HELP_LINK, '_blank');
};

export const getUserSession = () => {
  const service: IUserSession = angular.element(document.body).injector().get('UserSession');
  return snakeToCamelCase({
    company: service?.company,
    user: service?.user,
  }) as UserSession;
};

export const hasUserDirectPrintEnabled = () => {
  const { user, company } = getUserSession() as Required<UserSession>;
  const isFeatureFlagDirectPrintNode = company?.featureFlags.directPrintNodeFeature;
  return user?.printingSettings?.directPrintEnabled && isFeatureFlagDirectPrintNode;
};

export const formatHSCode = (code: string): string => {
  const cleanCode = code.replace(/\./g, '');
  if (cleanCode.length < 4) return cleanCode;
  if (cleanCode.length < 7) return `${cleanCode.slice(0, 4)}.${cleanCode.slice(4)}`;
  if (cleanCode.length < 9)
    return `${cleanCode.slice(0, 4)}.${cleanCode.slice(4, 6)}.${cleanCode.slice(6)}`;

  return `${cleanCode.slice(0, 4)}.${cleanCode.slice(4, 6)}.${cleanCode.slice(
    6,
    8
  )}.${cleanCode.slice(8)}`;
};

export const getScrollableParents = (el: HTMLElement): HTMLElement[] => {
  const parents: HTMLElement[] = [];
  let parent = el.parentElement;
  while (parent) {
    const style = getComputedStyle(parent);
    if (/(auto|scroll|overlay)/.test(style.overflow + style.overflowY + style.overflowX)) {
      parents.push(parent);
    }
    parent = parent.parentElement;
  }
  return parents;
};
